import React from 'react';
import type OpsGenieScheduleType from '@atlassian/jira-spa-apps-opsgenie-schedule/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { RedirectToProjectType } from './project-type/index.tsx';

export const LazyOpsGenieSchedule = lazyForPaint<typeof OpsGenieScheduleType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-opsgenie-schedule", jiraSpaEntry: "async-opsgenie-schedule" */ '@atlassian/jira-spa-apps-opsgenie-schedule'
		),
	),
);

export const OpsgenieScheduleRedirect = () => <RedirectToProjectType page="/on-call-schedule" />;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyOpsGenieSchedule} pageId="opsgenie-schedule" shouldShowSpinner />
);
